module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-panel-container",
    class: {
      'fixed-container': _vm.isFixedPanel, 'profile-container': _vm.type === 'profile'
    }
  }, [_c('div', {
    staticClass: "ibox message-panel",
    class: [{
      fixed: _vm.isFixedPanel
    }, _vm.getColumnLayoutClass]
  }, [_c('div', {
    staticClass: "ibox-title",
    style: ({
      'border-top': ("2px solid " + _vm.panelColor)
    })
  }, [(!_vm.isFixedPanel) ? _c('div', {
    staticClass: "drag-indicator"
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  })]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [(_vm.isLocked) ? _c('span', {
    staticClass: "locked"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]) : _vm._e(), _vm._v(" "), (_vm.hasNewMessages && _vm.lastScrollPosition > 0) ? _c('el-tooltip', {
    attrs: {
      "content": "New Message(s)"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": _vm.isLocked
    },
    on: {
      "click": _vm.scrollNewMessages
    }
  }, [_c('el-badge', {
    staticClass: "new-message",
    attrs: {
      "is-dot": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.scrolling && !_vm.isLocked) ? _c('el-tooltip', {
    attrs: {
      "content": "Scroll to top",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.scrollToTop
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLocked && _vm.type !== 'onair' && _vm.type !== 'twittertrends' && _vm.hasSearch) ? _c('el-tooltip', {
    attrs: {
      "content": ("" + (_vm.showPanelSearch ? 'Close Search' : 'Search Panel')),
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": _vm.getSearchBtnIcon('search')
    },
    on: {
      "click": _vm.toggleSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLocked && _vm.type !== 'onair' && _vm.type !== 'twittertrends' && _vm.hasSearch) ? _c('el-tooltip', {
    attrs: {
      "content": ("" + (_vm.showMediaSearch ? 'Close Media Search' : 'Search by Media')),
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": _vm.getSearchBtnIcon('media')
    },
    on: {
      "click": _vm.toggleMediaSearch
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSettings) ? _c('el-tooltip', {
    attrs: {
      "content": "Panel settings",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('showSettings')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.showClose && !_vm.settings.instant_poll && _vm.panelLocker === 'auto') ? _c('el-tooltip', {
    attrs: {
      "content": "Close panel",
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closePanel')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPanelSearch),
      expression: "showPanelSearch"
    }],
    staticClass: "panel-search"
  }, [_c('el-input', {
    staticStyle: {
      "margin": "5px auto"
    },
    attrs: {
      "placeholder": "Search",
      "size": "mini"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchPanelInteractions($event)
      }
    },
    model: {
      value: (_vm.searchCriteria),
      callback: function($$v) {
        _vm.searchCriteria = $$v
      },
      expression: "searchCriteria"
    }
  }, [_c('i', {
    staticClass: "el-icon-search el-input__icon",
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "fa fa-search"
    },
    on: {
      "click": _vm.searchPanelInteractions
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), (_vm.showMediaSearch) ? _c('div', {
    staticClass: "panel-search"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v("Use these options to search by specific media types.")]), _vm._v(" "), _c('div', {
    staticClass: "media-search"
  }, [_c('el-checkbox-group', {
    staticClass: "media-search-chk",
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.mediaSearchCriteria),
      callback: function($$v) {
        _vm.mediaSearchCriteria = $$v
      },
      expression: "mediaSearchCriteria"
    }
  }, _vm._l((_vm.mediaTypes), function(item) {
    return _c('el-tooltip', {
      key: item,
      attrs: {
        "content": item,
        "placement": "bottom"
      }
    }, [_c('el-checkbox-button', {
      attrs: {
        "label": item
      }
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.getMediaIconClass(item)
    })])], 1)
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "media-search-btn",
    attrs: {
      "icon": "fa fa-search",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.searchByMedia(false)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.settings.instant_poll) ? _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('h2', {
    attrs: {
      "id": "instant-poll-title"
    }
  }, [_vm._v(_vm._s(_vm.settings.name))]), _vm._v(" "), _vm._l((_vm.pollStats), function(result) {
    return _c('el-progress', {
      key: result.id,
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "text-inside": true,
        "stroke-width": 26,
        "format": function (percentage) { return ((result.choice) + " - " + (result.votes) + " votes - " + percentage + "%"); },
        "color": _vm.generateTitleColor(result.choice),
        "percentage": _vm.instantPollVotePercentage(result.votes)
      }
    })
  }), _vm._v(" "), _vm._m(0)], 2) : _vm._e(), _vm._v(" "), _c('perfect-scrollbar', {
    ref: 'content',
    staticClass: "ibox-content",
    on: {
      "ps-scroll-y": _vm.onScroll
    }
  }, [_c('div', {
    style: ({
      height: ((this.topHeight) + "px")
    })
  }), _vm._v(" "), (_vm.loadingTop) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    key: "top",
    attrs: {
      "count": 2
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.visibleClusters), function(cluster) {
    return _c('div', {
      key: cluster.id
    }, [(_vm.type != 'twittertrends') ? _vm._l((cluster.interactions), function(interaction) {
      return _c('div', {
        key: interaction.id
      }, [(
        interaction.channel != 'survey' && !interaction.message.startsWith('sha256:')
      ) ? _c('message', {
        staticClass: "message",
        class: {
          'first-message': interaction.id === _vm.firstInteractionId
        },
        attrs: {
          "audio": interaction.audio,
          "audioTranscript": _vm.getAudioTranscript(interaction.audioTranscript),
          "avatar": interaction.avatar,
          "channel": interaction.channel,
          "columns": (_vm.columns && +_vm.columns) || 1,
          "comments": interaction.comments,
          "datetime": interaction.datetime,
          "datetimeIsChanged": _vm.datetimeIsChanged,
          "displayName": interaction.displayName,
          "id": interaction.id,
          "threadId": interaction.threadId,
          "images": interaction.images,
          "isOnAir": _vm.type === 'onair',
          "message": interaction.message,
          "onAirUsers": _vm.onAirUsers,
          "originator": interaction.originator,
          "originatorType": interaction.originatorType,
          "parentInteraction": interaction.parent,
          "replies": interaction.replies,
          "sentOnAirBy": interaction.sentBy,
          "video": interaction.video,
          "document": interaction.document,
          "text": interaction.text,
          "sentiment": interaction.sentiment,
          "shouldPause": _vm.shouldPause(interaction.id),
          "inCount": _vm.getThreadCount(interaction.threadId, 'in'),
          "outCount": _vm.getThreadCount(interaction.threadId, 'out'),
          "mediaPreload": _vm.mediaPreload
        },
        on: {
          "changeDatetimePostFormat": _vm.changeDateFormat,
          "heightUpdated": _vm.heightUpdated,
          "mediaStarted": function($event) {
            return _vm.mediaStarted(interaction.id)
          },
          "mediaEnded": function($event) {
            return _vm.mediaEnded(interaction.id)
          },
          "removeOnAir": function($event) {
            return _vm.$emit('removeOnAir', [_vm.id, interaction.onAirId, interaction.id])
          },
          "onOpenProfile": function (originatorType, originator) { return _vm.$emit('onOpenProfile', originatorType, originator); }
        }
      }) : _vm._e()], 1)
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'twittertrends') ? _vm._l((_vm.twitterTrends), function(topic, index) {
      return _c('topic', {
        key: index,
        attrs: {
          "index": index,
          "topic": topic
        }
      })
    }) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.visibleClusters.length == 0 && !(_vm.loading || _vm.isLoading)) ? _c('div', [_c('content-placeholder', {
    key: "bottom",
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": 'No Interactions'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading && (_vm.hasMoreInteractions || !_vm.interactions.length)) ? _c('div', {
    staticClass: "placeholder",
    class: {
      'initial-placeholder': !_vm.interactions.length
    }
  }, [_c('content-placeholder', {
    key: "bottom",
    attrs: {
      "count": _vm.interactions.length ? 1 : 3
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.interactions.length && !_vm.hasMoreInteractions) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    key: "bottom",
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": 'End of Interactions'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    style: ({
      height: ((this.bottomHeight) + "px")
    })
  })], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "instant-profile-warning"
    }
  }, [_vm._v("\n          This panel will disappear 3 hours after the instant poll closes. The results can be\n          accessed at any time under the Campaigns menu. "), _c('br'), _vm._v("If this menu isn't available please\n          contact your administrator.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5029eb48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/MessagePanel.vue
// module id = 3280
// module chunks = 3